import { getData, postData, putData } from 'src/api/http.service';
import { ApiCallFailedAction, ApiCallInProgress, ApiCallSuccessAction } from './uistate.action';
import {
  getAPIEndpoints,
  handleApiSuccess,
  handleApiError,
  getDataFromSessionStorage,
} from 'src/utils';

const scholarshipActionTypes = {
  CREATE_SCHOLARSHIP: 'CREATE_SCHOLARSHIP',
  GET_ALL_SCHOLARSHIPS: 'GET_ALL_SCHOLARSHIPS',
  GET_STUDENT_SCHOLARSHIP_LIST: 'GET_STUDENT_SCHOLARSHIP_LIST',
  GET_STUDENT_NON_SCHOLARSHIP_LIST: 'GET_STUDENT_NON_SCHOLARSHIP_LIST',
  GET_STUDENT_SCHOLARSHIP_PAYMENT_INFO: 'GET_STUDENT_SCHOLARSHIP_PAYMENT_INFO',
};

const createScholarship = body => async dispatch => {
  dispatch(ApiCallInProgress());
  try {
    const response = await postData(`${getAPIEndpoints().scholarship}`, body, {
      userId: getDataFromSessionStorage('userInfo')?.userId,
    });
    dispatch(ApiCallSuccessAction({ message: 'Scholarship created successfully' }));
    return response;
  } catch (err) {
    dispatch(ApiCallFailedAction(handleApiError(err)));
    return err;
  }
};

const getScholarshipTypes = () => async dispatch => {
  try {
    const response = await getData(`${getAPIEndpoints().scholarshipTypes}`);
    return response?.data ?? [];
  } catch (err) {
    dispatch(ApiCallFailedAction(handleApiError(err)));
    return [];
  }
};

const editScholarship = body => async dispatch => {
  dispatch(ApiCallInProgress());
  try {
    const response = await putData(`${getAPIEndpoints().scholarship}`, body, {
      userId: getDataFromSessionStorage('userInfo')?.userId,
    });

    dispatch(ApiCallSuccessAction({ message: 'Scholarship updated successfully' }));
    return response;
  } catch (err) {
    dispatch(ApiCallFailedAction(handleApiError(err)));
    return err;
  }
};

const getAllScholarships = ({
  page = 0,
  size = 10,
  sort = 'DESC',
  sortBy = 'createdAt',
} = {}) => async dispatch => {
  dispatch(ApiCallInProgress());
  try {
    const response = await getData(
      `${getAPIEndpoints().scholarship}?page=${page}&size=${size}&sort=${sort}&sortBy=${sortBy}`
    );
    dispatch({ type: scholarshipActionTypes.GET_ALL_SCHOLARSHIPS, payload: response.data });
    dispatch(ApiCallSuccessAction({ message: '' }));
  } catch (err) {
    dispatch(ApiCallFailedAction(handleApiError(err)));
  }
};

let studentScholarshipListRequestId = 0;

const getStudentScholarshipList = ({
  page = 0,
  size = 10,
  sort = 'DESC',
  sortBy = 'updatedAt',
  startDate,
  endDate,
  search,
  status,
} = {}) => async dispatch => {
  const requestId = ++studentScholarshipListRequestId;
  dispatch(ApiCallInProgress());
  try {
    const updatedAtDateParams =
      startDate && endDate ? `&startDate=${startDate}&endDate=${endDate}` : '';
    const searchParam = search ? `&search=${encodeURIComponent(search)}` : '';
    const statusParam = status ? `&status=${status}` : '';
    const response = await getData(
      `${
        getAPIEndpoints().studentsScholarship
      }?page=${page}&size=${size}&sort=${sort}&sortBy=${sortBy}${updatedAtDateParams}${searchParam}${statusParam}&hasScholarship=true`
    );
    if (requestId !== studentScholarshipListRequestId) return;
    dispatch({ type: scholarshipActionTypes.GET_STUDENT_SCHOLARSHIP_LIST, payload: response.data });
    dispatch(ApiCallSuccessAction({ message: '' }));
  } catch (err) {
    if (requestId !== studentScholarshipListRequestId) return;
    dispatch(ApiCallFailedAction(handleApiError(err)));
  }
};

const getStudentScholarshipPaymentInfo = body => async dispatch => {
  dispatch(ApiCallInProgress());
  try {
    const response = await postData(`${getAPIEndpoints().studentScholarshipPaymentInfo}`, body, {
      userId: getDataFromSessionStorage('userInfo')?.userId,
    });

    dispatch(ApiCallSuccessAction({ message: '' }));
    return response;
  } catch (err) {
    dispatch(ApiCallFailedAction(handleApiError(err)));
    return false;
  }
};

const scholarshipDocumentVerification = body => async dispatch => {
  dispatch(ApiCallInProgress());
  try {
    const response = await putData(`${getAPIEndpoints().studentsScholarship}`, body, {
      userId: getDataFromSessionStorage('userInfo')?.userId,
    });

    let formattedResponse = handleApiSuccess(response);
    dispatch(ApiCallSuccessAction(formattedResponse));
    return formattedResponse;
  } catch (err) {
    dispatch(ApiCallFailedAction(handleApiError(err)));
    return false;
  }
};
//Non scholariship students actions
let studentNonScholarshipListRequestId = 0;

const getStudentNonScholarshipList = ({
  page = 0,
  size = 30,
  startDate,
  endDate,
  sort = 'DESC',
  sortBy = 'documentsUploadedAt',
  search,
  status,
} = {}) => async dispatch => {
  const requestId = ++studentNonScholarshipListRequestId;
  dispatch(ApiCallInProgress());
  try {
    const docsUploadedAtDateParams =
      startDate && endDate ? `&startDate=${startDate}&endDate=${endDate}` : '';
    const searchParam = search ? `&search=${encodeURIComponent(search)}` : '';
    const statusParam = status ? `&status=${status}` : '';
    const response = await getData(
      `${
        getAPIEndpoints().nonScholarshipStudents
      }?page=${page}&size=${size}&sort=${sort}&sortBy=${sortBy}${docsUploadedAtDateParams}${searchParam}${statusParam}`
    );

    if (requestId !== studentNonScholarshipListRequestId) return;
    dispatch({
      type: scholarshipActionTypes.GET_STUDENT_NON_SCHOLARSHIP_LIST,
      payload: response.data,
    });
    dispatch(ApiCallSuccessAction({ message: '' }));
  } catch (err) {
    if (requestId !== studentNonScholarshipListRequestId) return;
    dispatch(ApiCallFailedAction(handleApiError(err)));
  }
};

const getNonScholarshipDocuments = ({ studentId }) => async dispatch => {
  dispatch(ApiCallInProgress());
  try {
    const response = await getData(`${getAPIEndpoints().nonScholarshipDocuments}/${studentId}`);

    dispatch(ApiCallSuccessAction({ message: '' }));

    return response?.data ?? null;
  } catch (err) {
    dispatch(ApiCallFailedAction(handleApiError(err)));
    return null;
  }
};

const getStudentNonScholarshipPaymentInfo = studentId => async dispatch => {
  dispatch(ApiCallInProgress());
  try {
    const response = await getData(
      `${getAPIEndpoints().studentNonScholarshipPaymentInfo.replace('{studentId}', studentId)}`
    );
    dispatch(ApiCallSuccessAction({ message: '' }));
    return response;
  } catch (err) {
    dispatch(ApiCallFailedAction(handleApiError(err)));
    return false;
  }
};
const nonscholarshipDocumentVerification = body => async dispatch => {
  dispatch(ApiCallInProgress());
  try {
    const response = await putData(
      `${getAPIEndpoints().updateDocumentsOfNonScholarshipStudents}`,
      body,
      {
        userId: getDataFromSessionStorage('userInfo')?.userId,
      }
    );

    let formattedResponse = handleApiSuccess(response);
    dispatch(ApiCallSuccessAction(formattedResponse));
    return formattedResponse;
  } catch (err) {
    dispatch(ApiCallFailedAction(handleApiError(err)));
    return false;
  }
};

export {
  scholarshipActionTypes,
  getAllScholarships,
  createScholarship,
  editScholarship,
  getScholarshipTypes,
  getStudentScholarshipList,
  getStudentScholarshipPaymentInfo,
  scholarshipDocumentVerification,
  getStudentNonScholarshipList,
  getStudentNonScholarshipPaymentInfo,
  getNonScholarshipDocuments,
  nonscholarshipDocumentVerification,
};
